module.exports = __webpack_public_path__ + "img/假期休息@2x.6c814168.png";